"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientFieldCardDescription = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_messages_1 = require("@tableau/catalog-messages");
const DescriptionInfo_1 = require("../fieldColumn/DescriptionInfo");
const VizClientFieldCardStyles_1 = require("./VizClientFieldCardStyles");
function VizClientFieldCardDescription(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const field = props.field;
    if (field.description) {
        return react_1.default.createElement(DirectDescription, { description: field.description });
    }
    const column = maybeGetColumnFromField(field);
    if (column) {
        if (column.description) {
            return react_1.default.createElement(ColumnDescription, { column: column });
        }
        if (((_d = (_c = (_b = (_a = column.referencedByFlowColumnOutputField) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.parentFields) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.__typename) === 'FlowColumnInputField') {
            const upstreamColumn = (_h = (_g = (_f = (_e = column.referencedByFlowColumnOutputField) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.parentFields) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.column;
            if (upstreamColumn === null || upstreamColumn === void 0 ? void 0 : upstreamColumn.description) {
                return react_1.default.createElement(ColumnDescription, { column: upstreamColumn });
            }
        }
        // Fields downstream of VConns use remoteColumns
        if ((_j = column.remoteColumn) === null || _j === void 0 ? void 0 : _j.description) {
            const remoteColumn = column.remoteColumn;
            return react_1.default.createElement(ColumnDescription, { column: remoteColumn });
        }
    }
    if (field.__typename === 'DatasourceField') {
        const remoteField = field.remoteField;
        if (remoteField) {
            if (remoteField.description) {
                return react_1.default.createElement(RemoteFieldDescription, { remoteField: remoteField });
            }
            const remoteColumn = maybeGetColumnFromField(remoteField);
            if (remoteColumn) {
                if (remoteColumn.description) {
                    return (react_1.default.createElement(RemoteColumnDescription, { remoteColumn: remoteColumn, remoteField: remoteField }));
                }
                if ((_k = remoteColumn.remoteColumn) === null || _k === void 0 ? void 0 : _k.description) {
                    const fieldRemoteColumn = remoteColumn.remoteColumn;
                    return (react_1.default.createElement(RemoteColumnDescription, { remoteColumn: fieldRemoteColumn, remoteField: remoteField }));
                }
            }
            if (((_p = (_o = (_m = (_l = remoteField.referencedByFlowFieldOutputField) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.parentFields) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.__typename) === 'FlowColumnInputField') {
                const remoteUpstreamColumn = (_t = (_s = (_r = (_q = remoteField.referencedByFlowFieldOutputField) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.parentFields) === null || _s === void 0 ? void 0 : _s[0]) === null || _t === void 0 ? void 0 : _t.column;
                if (remoteUpstreamColumn === null || remoteUpstreamColumn === void 0 ? void 0 : remoteUpstreamColumn.description) {
                    return (react_1.default.createElement(RemoteColumnDescription, { remoteColumn: remoteUpstreamColumn, remoteField: remoteField }));
                }
                if ((_u = remoteUpstreamColumn === null || remoteUpstreamColumn === void 0 ? void 0 : remoteUpstreamColumn.remoteColumn) === null || _u === void 0 ? void 0 : _u.description) {
                    return (react_1.default.createElement(RemoteColumnDescription, { remoteColumn: remoteUpstreamColumn.remoteColumn, remoteField: remoteField }));
                }
            }
        }
    }
    return react_1.default.createElement(NoDescription, null);
}
exports.VizClientFieldCardDescription = VizClientFieldCardDescription;
function FieldCardDetailMarkup(props) {
    const { linksDisabled } = props, restProps = tslib_1.__rest(props, ["linksDisabled"]);
    return (react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailMarkupWrapper, null,
        react_1.default.createElement(widgets_1.TextFormatterDisplayWidget, Object.assign({}, restProps))));
}
function DirectDescription(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DescriptionTitle, null),
        react_1.default.createElement(FieldCardDetailMarkup, { markup: props.description })));
}
function ColumnDescription(props) {
    const description = props.column.description;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DescriptionTitle, { sourceColumn: props.column }),
        react_1.default.createElement(FieldCardDetailMarkup, { markup: description !== null && description !== void 0 ? description : '' })));
}
function RemoteFieldDescription(props) {
    var _a, _b;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DescriptionTitle, { sourceField: props.remoteField }),
        react_1.default.createElement(FieldCardDetailMarkup, { markup: (_b = (_a = props.remoteField) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : '' })));
}
function RemoteColumnDescription(props) {
    const description = props.remoteColumn.description;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DescriptionTitle, { sourceColumn: props.remoteColumn, sourceField: props.remoteField }),
        react_1.default.createElement(FieldCardDetailMarkup, { markup: description !== null && description !== void 0 ? description : '' })));
}
function NoDescription() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DescriptionTitle, null),
        react_1.default.createElement(VizClientFieldCardStyles_1.NoDescriptionPlaceholder, null, catalog_messages_1.Messages.NoDescriptionAvailable())));
}
function DescriptionTitle(props) {
    const sourceField = props.sourceField
        ? {
            __typename: props.sourceField.__typename,
            datasource: props.sourceField.datasource,
            description: props.sourceField.description,
            id: props.sourceField.id,
            name: props.sourceField.name,
        }
        : undefined;
    return (react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitleWrapper, null,
        react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitle, null,
            catalog_messages_1.Messages.Description(),
            react_1.default.createElement(DescriptionInfo_1.DescriptionInfo, Object.assign({ direction: 'horizontal' }, props, { sourceField: sourceField })))));
}
function maybeGetColumnFromField(field) {
    if (field.__typename === 'ColumnField') {
        const columnsConnection = field.columnsConnection;
        if (columnsConnection) {
            const columns = columnsConnection.nodes;
            if (columns && columns.length > 0) {
                const column = columns[0];
                if (column) {
                    return column;
                }
            }
        }
    }
    return null;
}
//# sourceMappingURL=VizClientFieldCardDescription.js.map